// extracted by mini-css-extract-plugin
module.exports = {"DataStoreSettings":"DataStoreSettings_WId9q","DataStoreSettingsButtonContainer":"DataStoreSettingsButtonContainer_6Cdy6"};